var r;!function(r){r.backward="backward",r.forward="forward"}(r||(r={}));export{r as Direction};
//# sourceMappingURL=types.js.map
